module.exports = __webpack_public_path__ + "static/img/SAD-3.f021663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SAD-3.jpg
// module id = 1Of6
// module chunks = 0